import React, { useEffect } from 'react-x';
import propTypes from 'prop-types-x';
import classNames from 'classnames';
import _isFunction from 'lodash/isFunction.js';
import { CssAnimation } from './CssAnimation.jsx';
import { multiplier } from '../../utilities/multiplier.js';

export function StepProgressTracker(props) {

  const { 
    steps, 
    currentStep, 
    label, 
    stepLabels, 
    showPagination,
    paginationDivider,
    autoCompleteOverride,
    onUpdateCallback,
    onClickCallback,
    verticalLayout,
    cssAnimation,
    cssAnimationDelay
  } = props;

  const block = 'c-step-progress-tracker';
  const Tag = onClickCallback ? 'button' : 'span';
  const stepsCompleted = autoCompleteOverride?.length ? autoCompleteOverride.filter(Boolean).length : currentStep;

  useEffect(() => {
    if (_isFunction(onUpdateCallback)) {
      onUpdateCallback(steps, currentStep);
    }
  }, [currentStep]);

  return (
    <CssAnimation 
    enter={{name: 'short-slide-up-fade-in', duration: 1.75, delay: `${cssAnimationDelay}, hidden` }}
    triggerEnter={true}
    disable={!cssAnimation}
    >
      <div className={block}>
        {
          (label || showPagination) &&
            <div className={`${block}__label`}>
              {
                label &&
                  <span className='list-item'>{label}</span>
              }
              {
                showPagination && 
                  <span className='list-item'>{` ${stepsCompleted} ${paginationDivider} ${steps}`}</span>
              }
            </div>
        }
        <ul className={classNames({
          [`${block}__step-indicators-container`]: true,
          [`${block}__step-indicators-container--vertical`]: verticalLayout
        })}>
          {
            [...Array(steps).fill('')].map((step, index) => (
              <CssAnimation
              enter={{ name: 'fade-in', duration: 0.5, delay: `${multiplier(index, 0.20, cssAnimationDelay + 0.5)}, hidden` }}
              triggerEnter={true}
              key={index}
              disable={!cssAnimation}
              >
                <li className={`${block}__step-indicator-wrapper`}>
                  <Tag onClick={() => onClickCallback(index)}>
                    <span 
                    className={classNames({
                      [`${block}__step-indicator`]: true,
                      [`${block}__step-indicator--active`]: index === currentStep,
                      [`${block}__step-indicator--completed`]: index < currentStep || autoCompleteOverride[index]
                    })}>
                    </span>
                    {
                      (stepLabels && stepLabels[index]) && 
                        <span className={classNames({
                          [`${block}__step-indicator-label list-item`]: true,
                          [`${block}__step-indicator-label--active`]: index === currentStep
                        })}>
                          {stepLabels[index]}
                        </span>
                    }
                  </Tag>
                </li>
              </CssAnimation>
            ))
          }
        </ul>
      </div>
    </CssAnimation>
  )
};

StepProgressTracker.propTypes = {
  steps: propTypes.number.isRequired,
  currentStep: propTypes.number.isRequired,
  label: propTypes.string,
  stepLabels: propTypes.array,
  showPagination: propTypes.bool,
  paginationDivider: propTypes.string,
  autoCompleteOverride: propTypes.array,
  onUpdateCallback: propTypes.func,
  onClickCallback: propTypes.func,
  verticalLayout: propTypes.bool,
  cssAnimation: propTypes.bool,
  cssAnimationDelay: propTypes.number
};

StepProgressTracker.defaultProps = {
  autoCompleteOverride: [],
  verticalLayout: false,
  cssAnimation: true,
  cssAnimationDelay: 0.1,
  paginationDivider: '/'
};